import styled from "styled-components";

const Input = styled.input`
  cursor: pointer;
`;

export default Input;
